import { PageView } from "components/materials/page/PageView";

export default function Page() {
  return <PageView />;
}
